// extracted by mini-css-extract-plugin
export default {"container":"nAEUA","topPanel":"Fwb7a","checkoutBtn":"LJq4e"};